import { FC, Fragment } from "react";
import React from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { PowerIcon, RelocationJunctionBoxIcon } from "../core/icons/Icons";
import { NumberInput } from "../core/NumberField";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
import { createStyles, makeStyles, InputLabel } from "@material-ui/core";

const textStyles = makeStyles(() =>
    createStyles({
        pText: {
            color: Colors.anthracite,
            fontStretch: "normal",
            fontFamily: "innogyWEB",
            fontSize: 22,
            fontWeight: 300,
            fontStyle: "normal",
            lineHeight: 1.27,
            letterSpacing: "normal",
        },
    }),
);

export const ModificationPowerCableJunctionBoxRelocationDistanceForm: FC = () => {
    const classes = useStyles();
    const classes2 = textStyles();
    const { values, setValues } = useFormModel<
        ChangeNames.MODIFICATION_POWER_CABLE_JUNCTION_BOX_RELOCATION_DISTANCE
    >();
    return (
        <div style={{ marginTop: 32 }}>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<PowerIcon />}
                content={
                    <Fragment>
                        <div style={{ display: "flex", flexDirection: "row" }}>
                            <p
                                className={classes2.pText}
                                style={{ marginTop: 0, marginBottom: 24, flex: 1 }}
                            >
                                Um wieviele Meter soll der Hausanschlusskasten innerhalb des Raumes
                                versetzt werden?
                            </p>
                            <RelocationJunctionBoxIcon />
                        </div>
                        <InputLabel className={classes.labledTextfieldLabel}>
                            Verlängerung
                        </InputLabel>
                        <NumberInput
                            className={classes.textField}
                            fixedDecimalScale={false}
                            allowLeadingZeros={false}
                            decimalScale={
                                values.modificationPowerCableJunctionBoxRelocationDistance.value
                                    .precision
                            }
                            isNumericString={false}
                            allowNegative={false}
                            thousandSeparator="."
                            decimalSeparator=","
                            adornment={
                                values.modificationPowerCableJunctionBoxRelocationDistance.value
                                    .unit
                            }
                            value={
                                values.modificationPowerCableJunctionBoxRelocationDistance.value
                                    .amount.num || ""
                            }
                            placeholder="0"
                            onValueChange={v =>
                                setValues(values => {
                                    values.modificationPowerCableJunctionBoxRelocationDistance.value.amount.num =
                                        v.floatValue || null;
                                })
                            }
                            error={
                                values.modificationPowerCableJunctionBoxRelocationDistance.error !==
                                null
                            }
                        />
                    </Fragment>
                }
            />
        </div>
    );
};
